import { useLocation, useNavigate } from "react-router-dom";
import React, { useLayoutEffect } from "react";
import { Box, Button, Card, Tab, Tabs, Typography } from "@mui/material";
import CustomerDetails from "../../../features/orders/CustomerDetails";
import ProductsOrdered from "../../../features/orders/ProductsOrdered";
import useTranslation from "../../../hooks/Translation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CustomerOrderDetails = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useLayoutEffect(() => {
    if (state) {
      setValue(state);
    }
  }, [state]);
  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.main.orderDetails}</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-Order");
            }}
          >
            {t.main.back}
          </Button>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label={t.main.customerDetails} {...a11yProps(0)} />
                <Tab label={t.main.productsOrdered} {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <CustomerDetails />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              <ProductsOrdered />
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default CustomerOrderDetails;
